import { Button } from "../../atoms"
import { MessageCard } from "../../molecules/MessageCard"



type DeclineMatchProps = {
  name:string,
  fromSender:boolean,
  isOld:boolean
}

export const DeclineMatchMessage = ({name,fromSender} : DeclineMatchProps)=>{
  

    return (
        <MessageCard className="" fromSender={fromSender}>
          {fromSender ?
           <p className="p-0 m-0"> You declined the match</p>
          :
           <p className="p-0 m-0 ">{name}  declined the match</p>
          } 
        </MessageCard>
    )
}